import _ from "lodash";
import LOCATIONS from "../../constants/LOCATIONS";

export const getLocation = (input) => LOCATIONS[_.lowerCase(_.trim(input))];

export default (input) => Boolean(getLocation(input));
